export const affirmData = [
    {
        id: 1,
        text: 'I forgive myself and set myself free.'
    },
    {
        id: 2,
        text: 'I believe I can be all that I want to be.'
    },
    {
        id: 3,
        text: 'I am in the process of becoming the best version of myself.'
    },
    {
        id: 4,
        text: 'I have the freedom & power to create the life I desire.'
    },
    {
        id: 5,
        text: 'I choose to be kind to myself and love myself unconditionally.'
    },
    {
        id: 6,
        text: 'My possibilities are endless.'
    },
    {
        id: 7,
        text: 'I am worthy of my dreams.'
    },
    {
        id: 8,
        text: 'I am enough.'
    },
    {
        id: 9,
        text: 'I deserve to be healthy and feel good.'
    },
    {
        id: 10,
        text: 'I am full of energy and vitality and my mind is calm and peaceful.'
    },
    {
        id: 11,
        text: 'Every day I am getting healthier and stronger.'
    },
    {
        id: 12,
        text: 'I honor my body by trusting the signals that it sends me.'
    },
    {
        id: 13,
        text: 'I manifest perfect health by making smart choices.'
    }
]